export enum Roles {
  INDmeLevel1Reviewer = 'IN_D1U',
  INMedicationLevel1Reviewer = 'IN_LV1',
  INMtgConfirmationLevel1Reviewer = 'IN_M1U',
  INMtgVarianceLevel1Reviewer = 'IN_V1U',
  INMtgSpecialServicesLevel1Reviewer = 'IN_S1U',
  INNonMtgUnder1000Level1Reviewer = 'IN_U1U',
  INNonMtgOver1000Level1Reviewer = 'IN_O1U',
  PBReviewer = 'PB_MPU',
  TPDmeLevel1Reviewer = 'TP_D1U',
  TPMedicationLevel1Reviewer = 'TP_LV1',
  TPMtgConfirmationLevel1Reviewer = 'TP_M1U',
  TPMtgVarianceLevel1Reviewer = 'TP_V1U',
  TPMtgSpecialServicesLevel1Reviewer = 'TP_S1U',
  TPNonMtgUnder1000Level1Reviewer = 'TP_U1U',
  TPNonMtgOver1000Level1Reviewer = 'TP_O1U',
  URL1Reviewer = 'UR_R1U',
  INDmeLevel2Reviewer = 'IN_D2U',
  INMedicationLevel2Reviewer = 'IN_LV2',
  INMtgConfirmationLevel2Reviewer = 'IN_M2U',
  INMtgVarianceLevel2Reviewer = 'IN_V2U',
  INMtgSpecialServicesLevel2Reviewer = 'IN_S2U',
  INNonMtgUnder1000Level2Reviewer = 'IN_U2U',
  INNonMtgOver1000Level2Reviewer = 'IN_O2U',
  TPDmeLevel2Reviewer = 'TP_D2U',
  TPMedicationLevel2Reviewer = 'TP_LV2',
  TPMtgConfirmationLevel2Reviewer = 'TP_M2U',
  TPMtgVarianceLevel2Reviewer = 'TP_V2U',
  TPMtgSpecialServicesLevel2Reviewer = 'TP_S2U',
  TPNonMtgUnder1000Level2Reviewer = 'TP_U2U',
  TPNonMtgOver1000Level2Reviewer = 'TP_O2U',
  URL2Reviewer = 'UR_R2U',
  INDmeWorkLoadAdministrator = 'IN_DMW',
  INMedicationWorkLoadAdministrator = 'IN_A1W',
  INMtgNonMtgWorkLoadAdministrator = 'IN_MTW',
  PBWorkloadAdmin = 'PB_MPW',
  TPDmeWorkLoadAdministrator = 'TP_DMW',
  TPMedicationWorkLoadAdministrator = 'TP_A1W',
  TPMtgNonMtgWorkLoadAdministrator = 'TP_MTW',
  URWorkloadAdmin = 'UR_URW',
  HPProviderDelegate = 'HP_DS',
  HPBillingDelegate = 'HP_DU',
}

export const Level1ReviewerRoles: string[] = [
  Roles.INDmeLevel1Reviewer.valueOf(),
  Roles.INMedicationLevel1Reviewer.valueOf(),
  Roles.INMtgConfirmationLevel1Reviewer.valueOf(),
  Roles.INMtgVarianceLevel1Reviewer.valueOf(),
  Roles.INMtgSpecialServicesLevel1Reviewer.valueOf(),
  Roles.INNonMtgUnder1000Level1Reviewer.valueOf(),
  Roles.INNonMtgOver1000Level1Reviewer.valueOf(),
  Roles.PBReviewer.valueOf(),
  Roles.TPDmeLevel1Reviewer.valueOf(),
  Roles.TPMedicationLevel1Reviewer.valueOf(),
  Roles.TPMtgConfirmationLevel1Reviewer.valueOf(),
  Roles.TPMtgVarianceLevel1Reviewer.valueOf(),
  Roles.TPMtgSpecialServicesLevel1Reviewer.valueOf(),
  Roles.TPNonMtgUnder1000Level1Reviewer.valueOf(),
  Roles.TPNonMtgOver1000Level1Reviewer.valueOf(),
  Roles.URL1Reviewer.valueOf(),
];

export const Level2ReviewerRoles: string[] = [
  Roles.INDmeLevel2Reviewer.valueOf(),
  Roles.INMedicationLevel2Reviewer.valueOf(),
  Roles.INMtgConfirmationLevel2Reviewer.valueOf(),
  Roles.INMtgVarianceLevel2Reviewer.valueOf(),
  Roles.INMtgSpecialServicesLevel2Reviewer.valueOf(),
  Roles.INNonMtgUnder1000Level2Reviewer.valueOf(),
  Roles.INNonMtgOver1000Level2Reviewer.valueOf(),
  Roles.TPDmeLevel2Reviewer.valueOf(),
  Roles.TPMedicationLevel2Reviewer.valueOf(),
  Roles.TPMtgConfirmationLevel2Reviewer.valueOf(),
  Roles.TPMtgVarianceLevel2Reviewer.valueOf(),
  Roles.TPMtgSpecialServicesLevel2Reviewer.valueOf(),
  Roles.TPNonMtgUnder1000Level2Reviewer.valueOf(),
  Roles.TPNonMtgOver1000Level2Reviewer.valueOf(),
  Roles.URL2Reviewer.valueOf(),
];

export const WorkloadAdminRoles: string[] = [
  Roles.INDmeWorkLoadAdministrator.valueOf(),
  Roles.INMedicationWorkLoadAdministrator.valueOf(),
  Roles.INMtgNonMtgWorkLoadAdministrator.valueOf(),
  Roles.PBWorkloadAdmin.valueOf(),
  Roles.TPDmeWorkLoadAdministrator.valueOf(),
  Roles.TPMedicationWorkLoadAdministrator.valueOf(),
  Roles.TPMtgNonMtgWorkLoadAdministrator.valueOf(),
  Roles.URWorkloadAdmin.valueOf(),
];

export const POREWorkloadAdminRoles: string[] = [
  Roles.INDmeWorkLoadAdministrator.valueOf(),
  Roles.INMedicationWorkLoadAdministrator.valueOf(),
  Roles.INMtgNonMtgWorkLoadAdministrator.valueOf(),
  Roles.TPDmeWorkLoadAdministrator.valueOf(),
  Roles.TPMedicationWorkLoadAdministrator.valueOf(),
  Roles.TPMtgNonMtgWorkLoadAdministrator.valueOf(),
];
